__turbopack_context__.v({
  "content": "BfgIta_content",
  "fullPage": "BfgIta_fullPage",
  "guidance": "BfgIta_guidance",
  "overlay": "BfgIta_overlay",
});
